import { useEffect, useState, useRef } from "react";

const ScrollingItems = ({ items }) => {
	const containerRef = useRef(null);
	const [shouldScroll, setShouldScroll] = useState(false);

	// Check if scrolling is necessary based on the items' total width
	useEffect(() => {
		const checkOverflow = () => {
			const container = containerRef.current;
			const itemsWrapper = container.querySelector(".scroll");
			if (itemsWrapper && itemsWrapper.scrollWidth > container.clientWidth) {
				setShouldScroll(true); // Enable scroll animation if the content is wider
			} else {
				setShouldScroll(false); // Disable scroll animation if not necessary
			}
		};

		checkOverflow();
		window.addEventListener("resize", checkOverflow); // Recheck when resizing
		return () => window.removeEventListener("resize", checkOverflow);
	}, [items]); // Recheck if items change

	return (
		<div
			ref={containerRef}
			className="absolute z-50 top-1 left-1/2 transform -translate-x-1/2 flex space-x-2 mb-2 w-full max-w-[100vw] overflow-hidden border-r-8 border-l-8 border-t-4 border-b-4 rounded-xl border-[#fbb554] bg-[#444] p-2 shadow-[0px_6px_0px_rgba(218,152,59,1)]"
			style={{
				width: "95%", // Set the container to the full width of the parent
			}}
		>
			<div
				className={`flex gap-2 scroll scrolling ${
					shouldScroll ? "scrolling" : ""
				}`}
				id="scroll-one"
			>
				{/* Mapping through items */}
				{[...items, ...items, ...items, ...items].map((item, index) => (
					<div
						key={index}
						className="bg-white rounded-xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] flex flex-col min-w-28 w-28 h-[80px] overflow-hidden items-center justify-start"
					>
						<div
							className="bg-contain bg-no-repeat bg-center min-h-[40px] min-w-12 h-[40px] w-12 max-h-[40px] max-w-12"
							style={{
								backgroundImage: item.icon ? `url(${item.icon})` : "none",
							}}
						/>
						<div className="text-sm text-gray-700 uppercase text-center w-28 whitespace-pre-wrap">
							{item.name}
						</div>
					</div>
				))}
			</div>
			<div className="fade"></div>
		</div>
	);
};

export default ScrollingItems;
